<div class="register-page">

  <div class="register-card">

    <h2>{{ t('createAccount') }}</h2>

    <p>{{ t('joinSuperBangladesh') }}</p>

    <div class="form-group">
      <label>{{ t('fullNameLabel') }}</label>
      <input
        type="text"
        name="fullName"
        id="fullName"
        autocomplete="name"
        [(ngModel)]="fullName"
        [placeholder]="t('enterYourFullName')">
    </div>

    <div class="form-group">
      <label>{{ t('emailLabel') }}</label>
      <input
        type="email"
        name="email"
        id="regEmail"
        autocomplete="username"
        [(ngModel)]="email"
        [placeholder]="t('enterYourEmail')">
    </div>

    <div class="form-group">
      <label>{{ t('phoneLabelForm') }}</label>
      <input
        type="text"
        name="phone"
        id="phone"
        autocomplete="tel"
        [(ngModel)]="phone"
        [placeholder]="t('enterYourPhoneNumber')">
    </div>

    <div class="form-group">
      <label>{{ t('addressLabelForm') }}</label>
      <textarea
        rows="3"
        name="address"
        id="address"
        autocomplete="street-address"
        [(ngModel)]="address"
        [placeholder]="t('enterYourAddress')">
      </textarea>
    </div>

    <div class="form-group">
      <label>{{ t('password') }}</label>
      <input
        type="password"
        name="password"
        id="regPassword"
        autocomplete="new-password"
        [(ngModel)]="password"
        [placeholder]="t('enterPassword')">
    </div>

    <div class="form-group">
      <label>{{ t('confirmPasswordLabel') }}</label>
      <input
        type="password"
        name="confirmPassword"
        id="confirmPassword"
        autocomplete="new-password"
        [(ngModel)]="confirmPassword"
        [placeholder]="t('confirmPasswordPlaceholder')">
    </div>

    <button
      class="register-btn"
      (click)="register()"
      [disabled]="loading">

      {{ loading ? t('creatingAccount') : t('createAccount') }}

    </button>

    <p class="login-link">

      {{ t('alreadyHaveAccount') }}

      <a routerLink="/login">
        {{ t('login') }}
      </a>

    </p>

  </div>

</div>
